
const CreatePageInfo = function(page, itemsPerPage, onDisplay){
    const pageInfo = Object.freeze({
        pageNumber : page, 
        limitPerPage : itemsPerPage, 
        isOnDisplay : onDisplay
    });

    return pageInfo;
}

const QuestionnaireCreator = Object.freeze({
    CreatePageInfo : CreatePageInfo
});
export default QuestionnaireCreator